import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IInboundPromoCodesSlice {
  inboundPromoCodes: string[];
}

export const createInboundPromoCodesSliceDefaultValues = (): IInboundPromoCodesSlice => ({
  inboundPromoCodes: [],
});

export const createInboundPromoCodesSlice: StateCreator<IInboundPromoCodesSlice> = () =>
  createInboundPromoCodesSliceDefaultValues();

export type InboundPromoCodesPageStore = UseBoundStore<StoreApi<IInboundPromoCodesSlice>>;

export const createInboundPromoCodesHooks = (pageStore: InboundPromoCodesPageStore) => {
  return {
    useHasInboundPromoCodes: () => pageStore((state) => state.inboundPromoCodes.length > 0),
  };
};

export type InboundPromoCodesHooks = ReturnType<typeof createInboundPromoCodesHooks>;
